import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IModalsState} from "../../interfaces/IModalsState.ts";

const initialModalsState: IModalsState = {
    isEpgDetailsOpen: false,
    isChannelUnavailableOpen: false,
    isRequestToCloseModalSent: false,
    isFavoriteDetailsModalOpen: true,
}

export const modalsStateSlice = createSlice({
    name: "modalsState",
    initialState: initialModalsState,
    reducers: {
        setIsEpgDetailsOpen: (state: IModalsState, action: PayloadAction<boolean>) => {
            state.isEpgDetailsOpen = action.payload;
        },
        toggleIsEpgDetailsOpen: (state: IModalsState) => {
            state.isEpgDetailsOpen = !state.isEpgDetailsOpen;
        },
        setIsChannelUnavailableOpen: (state: IModalsState, action: PayloadAction<boolean>) => {
            state.isChannelUnavailableOpen = action.payload;
        },
        toggleIsChannelUnavailableOpen: (state: IModalsState) => {
            state.isChannelUnavailableOpen = !state.isChannelUnavailableOpen;
        },
        setIsRequestToCloseModalSent: (state: IModalsState, action: PayloadAction<boolean>) => {
            state.isRequestToCloseModalSent = action.payload;
        },
        setIsFavoriteDetailsModalOpen: (state: IModalsState, action: PayloadAction<boolean>) => {
            state.isFavoriteDetailsModalOpen = action.payload;
        }
    },
})

export const modalsStateActions = modalsStateSlice.actions;